import { useSelector } from 'react-redux'
import type { RenderableFilterOption, SelectedValues } from 'shared/types/util'

import { facetByIdSelector } from '~/app/store/facet'
import { filterOptionByIdSelector } from '~/app/store/filterOption'
import { refinementsHasRefSelector } from '~/app/store/refinement'
import type { State } from 'shared/types/gallery/state'

export const useFilterOptions = (filter: State.AttributeFilter): State.FilterOptions => {
  const getFacet = useSelector(facetByIdSelector)
  const getOption = useSelector(filterOptionByIdSelector)
  const isSelected = useSelector(refinementsHasRefSelector)

  const options: RenderableFilterOption[] = []

  if (filter) {
    options.push(
      ...filter.options
        .map((o: string) => {
          const facet = getFacet(o)
          const option = getOption(o) as RenderableFilterOption

          option.selected = !!isSelected(o)
          option.facetCount = 0
          option.disabled = !facet || facet.count <= 0
          return option
        })
        .filter((o) => o.facetCount != null),
    )
  }

  // only render the filter if there is at least one enabled item
  const visible = options.some((o) => !o.disabled)
  const selected = options.reduce(
    (accum, o) => ({
      ...accum,
      [o.value]: !!o.selected,
    }),
    {} as SelectedValues,
  )

  return {
    options,
    selected,
    visible,
  }
}
